import { React, useState } from "react";
import { useSelector } from "react-redux";

import RequestForm from "./Forms/RequestForm";
import PersonalizeForm from "./Forms/PersonalizeForm";
import RecipientForm from "./Forms/RecipientForm";
import ReturnForm from "./Forms/ReturnForm";
import EcardRecipientForm from "./Forms/EcardRecipientForm";
import ApproveForm from "./Forms/ApproveForm";
import AddToCartForm from "./Forms/AddToCartForm";

function FormArea() {
  const formStep = useSelector((state) => state.configurator.FormStep);

  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );

  return (
    <div>
      {formStep === "Request" && <RequestForm />}
      {formStep === "Personalize" && <PersonalizeForm />}
      {formStep === "Recipient" && (
        <RecipientForm />
      )}
      {formStep === "Return" && (
        <ReturnForm />
      )}
      {formStep === "EcardRecipient" && (
        <EcardRecipientForm />
      )}
      {formStep === "Approve" && <ApproveForm />}
      {formStep === "AddToCart" && <AddToCartForm />}

    </div>
  );
}

export default FormArea;
